module.exports = __webpack_public_path__ + "static/cega_logo-f3ad9cc781d52b342d7fee03ae1106c5.png";